import React, { useEffect, useState } from "react";
import { Testimonial_Type } from "../model";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components/Loading";

const TestimonialPage: React.FC = () => {
  const [testimonials, setTestimonials] = useState<Testimonial_Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      collection(db, "testimonials"),
      (snapshot) => {
        const data: Testimonial_Type[] = snapshot.docs.map(
          (doc) => doc.data() as Testimonial_Type
        );
        setTestimonials(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);

  return (
    <div className="bg-gray-100 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {(loading || !testimonials.length) && <Loading />}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 transform transition duration-300 hover:scale-105"
            >
              <p className="text-gray-800 mb-4">{testimonial.description}</p>
              <p className="text-gray-600 font-medium">{testimonial.name}</p>
              <p className="text-gray-500">{testimonial.company}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialPage;
